<div class="container h-full flex flex-col mx-auto px-4 md:px-6 pt-8 pb-4">
  <div class="flex flex-wrap items-center gap-2 mb-4 min-h-10">
    <h2 class="text-2xl font-medium flex-auto">

      @if(currentRoutePath(); as path) {
        {{ pageTitleMap[path] }}
      }

    </h2>

    @if(currentRoutePath() === 'templates') {
      <button *appHasPermission="'interaction:create'" mat-button (click)="handleAiAgentChat()">
        <mat-icon class="!text-purple-600">auto_awesome</mat-icon>
        Interactie maken met AI
      </button>
      <button *appHasPermission="'interaction:create'" mat-button (click)="handleInteractionAdd()">
        <mat-icon>add</mat-icon>

        @if(currentRoutePath(); as path) {
          Nieuwe template
        }
      </button>
    } @else {
      <button *appHasPermission="'interaction:create'" mat-button (click)="handleAiAgentChat()">
        <mat-icon class="!text-purple-600">auto_awesome</mat-icon>
        Interactie maken met AI
      </button>
      <button *appHasPermission="'interaction:create'" mat-button (click)="handleInteractionAdd()">
        <mat-icon>add</mat-icon>

        Nieuwe interactie
      </button>
      <button *appHasPermission="'interaction:create'" mat-button (click)="pickTemplate()">
        <mat-icon>article</mat-icon>

        Kies een template
      </button>
    }
  </div>

  <div class="bg-white p-4 rounded-t-lg flex flex-col gap-3">
    <div class="flex items-center gap-2">
      @if (canReadTags()) {
        <app-tag-filter
          class="block max-w-45"
          [disabled]="isSearchDisabled()"
          [tags]="filterTags()"
          [selectedTagIds]="selectedTagIds()"
          (selectedTagIdsChange)="handleTagFilterChange($event)"
        />
      }

      <mat-form-field
        subscriptSizing="dynamic"
        class="w-full [--mat-form-field-container-text-size:14px] [--mat-form-field-container-height:48px] [--mat-form-field-container-vertical-padding:12px]"
      >
        <mat-icon matPrefix> search </mat-icon>

        <input
          #searchInput
          matInput
          placeholder="Zoeken op naam..."
          [disabled]="isSearchDisabled()"
          [ngModel]="keyword()"
          (ngModelChange)="handleSearch(searchInput.value)"
        />

        @if (keyword()) {
          <button mat-icon-button matSuffix class="mr-1" (click)="clearSearch()">
            <mat-icon>cancel</mat-icon>
          </button>
        }
      </mat-form-field>
    </div>

    @if (currentRoutePath() === 'templates') {
      <div class="flex items-center gap-2">
        <mat-chip-listbox
          class="[--mdc-chip-elevated-selected-container-color:var(--color-secondary-200)] [--mdc-chip-selected-label-text-color:var(--color-secondary-800)]"
        >
          <mat-chip-option
            [selected]="includeShared()"
            (selectionChange)="handleIncludeSharedChange($event.selected)"
          >
            Gedeelde templates tonen
          </mat-chip-option>
        </mat-chip-listbox>
      </div>
    }

    @if (selectedTagIds().length) {
      <div class="flex flex-wrap gap-1 mt-2">
        @for (tag of selectedTags(); track tag.id) {
          <div class="inline-flex items-center gap-1 bg-gray-300 text-gray-800 py-1 pl-2 rounded-full text-xs font-medium">
            <span>{{ tag.label }}</span>
            <button mat-icon-button class="p-0! inline-flex! items-center! justify-center! mr-1 size-5! hover:text-gray-800!" (click)="removeTag(tag.id)">
              <mat-icon class="text-base! size-4! leading-none! font-medium!">cancel</mat-icon>
            </button>
          </div>
        }
      </div>
    }
  </div>

  <app-data-table-container class="rounded-b-lg!">
    <table
      mat-table
      matSort
      matSortDirection="desc"
      matSortActive="created_at"
      matSortDisableClear
      [matSortDisabled]="hasNoData()"
      (matSortChange)="handleSortChange($event)"
      [dataSource]="dataSource()"
    >
      <ng-container matColumnDef="label" sticky>
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Naam</th>
        <td mat-cell *matCellDef="let element" [class.opacity-50]="element.moveId">
          <div class="flex items-center gap-1.5">
            <span
              class="w-min max-w-40 truncate block"
              [matTooltip]="element.label"
              matTooltipPosition="after"
              >{{ element.label ?? '-' }}
            </span>

            @if (element.shareId && !element.isShared && currentRoutePath() === 'templates') {
              <span
                class="bg-green-100 text-green-800 py-1 px-2 rounded-full text-xs font-medium whitespace-nowrap"
                matTooltip="Gedeeld met onderliggende units"
              >
                Gedeeld
              </span>
            }
          </div>
          @if (element.moveId) {
            <span class="text-xs text-orange-500 font-medium">Een verplaatsing is bezig...</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="tags">
        <th mat-header-cell *matHeaderCellDef>Tags</th>
        <td mat-cell *matCellDef="let element" [class.opacity-50]="element.moveId">
          @if (element.tags.length) {
            <div class="flex flex-nowrap gap-1">
              @let sortedTags = getSortedTags(element.tags);
              @for (tag of sortedTags.slice(0, 2); track tag.id) {
                @if (tag.status === 'inactive') {
                  <span
                    class="bg-gray-100 text-gray-400 py-0.5 px-2 rounded-full text-xs font-medium truncate max-w-24"
                    [matTooltip]="tag.label + ' (inactief)'"
                  >
                    {{ tag.label }}
                  </span>
                } @else {
                  <span
                    class="bg-gray-200 text-gray-700 py-0.5 px-2 rounded-full text-xs font-medium truncate max-w-24"
                    [matTooltip]="tag.label"
                  >
                    {{ tag.label }}
                  </span>
                }
              }
              @if (element.tags.length > 2) {
                <span
                  class="bg-gray-200 text-gray-700 py-0.5 px-2 rounded-full text-xs font-medium"
                  [matTooltip]="getOverflowTagsTooltip(sortedTags)"
                >
                  +{{ element.tags.length - 2 }}
                </span>
              }
            </div>
          } @else {
            -
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="estimatedDuration">
        <th mat-header-cell *matHeaderCellDef>Geschatte duratie</th>
        <td mat-cell *matCellDef="let element" [class.opacity-50]="element.moveId">
          {{ element.estimatedDuration | secondsToDuration }}
        </td>
      </ng-container>

      <ng-container matColumnDef="version">
        <th mat-header-cell *matHeaderCellDef>Versie</th>
        <td mat-cell *matCellDef="let element" [class.opacity-50]="element.moveId">
          <span
            class="bg-gray-300 text-gray-800 py-1 px-2 rounded-full text-xs font-medium"
          >
            v{{ element.version }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell mat-sort-header="created_at" *matHeaderCellDef>
          Aangemaakt op
        </th>
        <td mat-cell *matCellDef="let element" [class.opacity-50]="element.moveId">
          {{ element.createdAt | date: 'MMMM dd, yyyy HH:mm' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell mat-sort-header="updated_at" *matHeaderCellDef>
          Laatst bewerkt op
        </th>
        <td mat-cell *matCellDef="let element" [class.opacity-50]="element.moveId">
          {{ element.updatedAt | date: 'MMMM dd, yyyy HH:mm' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="sharedBy">
        <th mat-header-cell *matHeaderCellDef>Gedeeld door</th>
        <td mat-cell *matCellDef="let element" [class.opacity-50]="element.moveId">
          @if (element.isShared) {
            <span
              class="w-min max-w-40 truncate block"
              [matTooltip]="element.ownerUnitName"
              matTooltipPosition="after"
              >{{ element.ownerUnitName }}
            </span>
          }
          @else {
            -
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          @if (element.moveId) {
            <div>
              <span class="text-xs text-gray-400">Een verplaatsing is bezig</span>
            </div>
          } @else if (element.isShared) {
            <!-- Shared template from another unit: read-only -->
            <button mat-icon-button matTooltip="Bekijken" (click)="navigateToInteraction(element._id)">
              <mat-icon>visibility</mat-icon>
            </button>
          } @else {
            <button *appHasPermission="['interaction:update', 'interaction:delete', 'interaction:create', 'interaction:share', 'interaction:move']" mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Meer">
              <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #menu="matMenu">
              <button *appHasPermission="'interaction:update'" mat-menu-item (click)="handleInteractionNameEdit(element)">
                Naam wijzigen
              </button>

              <button *appHasPermission="'interaction:update'" mat-menu-item (click)="navigateToInteraction(element._id)">
                Bewerken
              </button>

              <button *appHasPermission="'interaction:create'" mat-menu-item (click)="handleInteractionDuplicate(element)">
                Dupliceren
              </button>

              @if (currentRoutePath() === 'templates') {
                @if (!element.shareId) {
                  <button *appHasPermission="'interaction:share'" mat-menu-item (click)="handleShare(element)">
                    Delen
                  </button>
                } @else {
                  <button *appHasPermission="'interaction:share'" mat-menu-item (click)="handleUnshare(element)">
                    Niet meer delen
                  </button>
                }

                <div [matTooltip]="element.shareId ? 'Verwijder eerst het delen voordat je de template verplaatst' : ''">
                  <button *appHasPermission="'interaction:move'" mat-menu-item [disabled]="!!element.shareId" (click)="handleMove(element)">
                    Verplaatsen
                  </button>
                </div>
              }

              <button *appHasPermission="'interaction:delete'" mat-menu-item (click)="handleInteractionDelete(element)">
                Verwijderen
              </button>
            </mat-menu>
          }
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns(); sticky: true"
        class="whitespace-nowrap"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns()"
        class="hover:!bg-gray-100 whitespace-nowrap"
        (dblclick)="!row.moveId && navigateToInteraction(row._id)"
      ></tr>

      <tr class="mat-mdc-row" *matNoDataRow>
        <td
          class="mat-mdc-cell mdc-data-table__cell !border-none"
          [colSpan]="displayedColumns().length"
        >
          Geen resultaten gevonden
        </td>
      </tr>
    </table>

    <mat-paginator
      class="border-t border-(--mat-table-row-item-outline-color)"
      (page)="handlePageChange($event)"
      [pageSize]="pageSize()"
      [pageSizeOptions]="[25, 50, 100]"
    ></mat-paginator>
  </app-data-table-container>
</div>
